import gql from 'graphql-tag';

export const INSERT_COLLEGES = gql`
  mutation insertColleges($data: [colleges_insert_input!]!) {
    insert_colleges(
      objects: $data
      on_conflict: {
        constraint: colleges_pkey
        update_columns: [deadline_url, name, website_url]
      }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_COLLEGE = gql`
    mutation deleteCollege($id: Int!) {
        delete_colleges_by_pk(id: $id) {
            id
        }
    }
`;

export const GET_COLLEGES = gql`
  query getColleges($query: String, $offset: Int!, $limit: Int!) {
    colleges(
      where: { name: { _ilike: $query } }
      limit: $limit
      offset: $offset
      order_by: [{ name: asc }]
    ) {
      id
      name
      website_url
      deadline_url
      deadlines {
        id
        program_type
        admission_type
        deadline
        flagged
        flagged_by
        flagged_user {
          user_first_name
          user_last_name
        }
        suggested_date
      }
    }
    colleges_aggregate(where: { name: { _ilike: $query } }) {
      aggregate {
        count
      }
    }
  }
`;

export const INSERT_DEADLINES = gql`
  mutation addDeadlines($data: [college_application_deadlines_insert_input!]!) {
    insert_college_application_deadlines(
      objects: $data
      on_conflict: {
        constraint: college_application_deadlines_pkey
        update_columns: [admission_type, program_type, deadline]
      }
    ) {
      affected_rows
    }
  }
`;

export const UPDATE_DEADLINE = gql`
  mutation updateDadline(
    $id: Int!
    $data: college_application_deadlines_set_input
  ) {
    update_college_application_deadlines_by_pk(
      pk_columns: { id: $id }
      _set: $data
    ) {
      id
      program_type
      admission_type
      deadline
      flagged
      flagged_by
      flagged_user {
        user_first_name
        user_last_name
      }
      suggested_date
    }
  }
`;

export const DELETE_DEADLINE = gql`
    mutation deleteDeadline($id: Int!) {
        delete_college_application_deadlines_by_pk(id: $id) {
            id
        }
    }
`;

export const GET_COLLEGE_DEADLINES = gql`
  query getDeadlines($id: Int) {
    rows: college_application_deadlines(
      where: { college_id: { _eq: $id } }
      order_by: { college: { name: asc } }
    ) {
      id
      program_type
      admission_type
      deadline
      flagged
      flagged_by
      suggested_date
      college {
        id
        name
      }
    }
  }
`;

export const GET_FLAGGED_DEADLINES = gql`
  query getDeadlines {
    rows: college_application_deadlines(
      where: { flagged: { _eq: true } }
      order_by: { deadline: asc }
    ) {
      id
      program_type
      admission_type
      deadline
      flagged
      flagged_user {
        user_last_name
        user_first_name
      }
      suggested_date
      college {
        name
        id
      }
    }
  }
`;

export const GET_LOGS = gql`
  query getLogs($id: Int!) {
    rows: college_application_deadline_logs(
      where: { deadline_id: { _eq: $id } }
      order_by: { created_at: desc }
    ) {
      id
      message
      created_at
      user {
        user_first_name
        user_last_name
      }
    }
  }
`;

export const GET_ADMISSION_TYPES = gql`
    query {
        college_application_deadlines_aggregate(
            distinct_on:admission_type
        ) {
            aggregate {
                count
            }
            nodes {
                admission_type
            }
        }
    }
`